module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./JobSampleManageView.js"));
	}, "batchManageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=batchManageView!./src/pages/DispatchCenter/JobSampleManage/JobSampleManageView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=batchManageView!./src/pages/DispatchCenter/JobSampleManage/JobSampleManageView.js
// module chunks = 43